type HeaderlessMobileLayoutProps = {
  children: React.ReactNode;
};

const HeaderlessMobileLayout = ({ children }: HeaderlessMobileLayoutProps) => {
  return (
    <>
      <main className="mx-auto max-w-header grid grid-cols-12 py-40 sm:py-32 px-20 sm:px-28">
        <div className="col-span-12 md:col-span-6 md:col-start-4">
          {children}
        </div>
      </main>
    </>
  );
};
export default HeaderlessMobileLayout;
